<template>
  <div
    class="container button"
    v-bind:class="{ disable: _disabled }"
    tabindex="0"
  >
    <input
      :id="id"
      type="button"
      :disabled="_disabled"
      :style="{ backgroundColor: color, padding, width }"
      @click="validate"
      :value="label"
    />
  </div>
</template>

<script>
import { get } from "@/utils";
export default {
  name: "SalesButton",
  props: {
    label: String,
    id: String,
    width: String,
    color: {
      type: String,
      default: "#1973b5"
    },
    disable: {
      type: Boolean,
      default: false
    },
    padding: {
      type: String,
      default: "0 30px"
    }
  },
  data() {
    return {
      formValidator: this.$parent
    };
  },
  mounted() {
    // Busco el form validator que lo envuelve (si existe)
    let elem = this.$parent;
    while (elem && !elem.validate) {
      elem = elem.$parent;
    }
    this.formValidator = elem;
  },
  methods: {
    validate() {
      let valid = false;
      if (this.formValidator) {
        valid = this.formValidator.validate();
      }

      if (valid) {
        this.$emit("click");
      } else {
        return false;
      }
    }
  },
  computed: {
    _disabled() {
      return (
        this.disable ||
        get(this.formValidator, "$data.validForm", null) === false
      );
    }
  }
};
</script>

<style scoped>
div.container {
  padding: 0;
  margin: auto;
  display: inline-block;
  width: 100%;
}
input {
  height: 56px;
  border-radius: 1px;
  color: white;
  border: none;
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  width: 100%;
  min-width: 128px;
  cursor: pointer;
}

/* disable */
div.container.disable {
  position: relative;
  overflow: hidden;
}

div.container.disable::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.5);
}

div.container.disable::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  /* width: 100%; */
  height: 4px;
  z-index: 2;
  background-color: #00a5a6;
  animation: animate-line 1s ease-in-out infinite;
}

@keyframes animate-line {
  0% {
    width: 0;
    left: 0;
  }
  50% {
    width: 100%;
  }
  100% {
    left: 100%;
    width: 0;
  }
}
</style>
